import { useEffect, useState } from 'react';

function ringColor(score) {
  if (score >= 80) return '#6ee7b7';
  if (score >= 50) return '#fcd34d';
  return '#fda4af';
}

export function SeoScoreRing({ score, size = 44, onImprove, improving = false }) {
  const value = Math.max(0, Math.min(100, Number(score) || 0));
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setProgress(value));
    return () => cancelAnimationFrame(frame);
  }, [value]);

  const radius = 15.5;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;
  const fontSize = size >= 88 ? 22 : size >= 64 ? 16 : 13;

  return (
    <span className="inline-flex flex-col items-center shrink-0">
      <span
        className="relative inline-flex items-center justify-center rounded-full"
        style={{
          width: size,
          height: size,
          background: 'radial-gradient(circle at 35% 30%, #f4ff8a 0%, #c6ff3d 42%, #39ff14 78%)',
          boxShadow: '0 0 22px rgba(57, 255, 20, 0.75)',
        }}
        title={`SEO ${value}`}
        aria-label={`SEO score ${value}`}
      >
        <svg viewBox="0 0 40 40" className="h-full w-full -rotate-90" aria-hidden="true">
          <circle cx="20" cy="20" r={radius} fill="none" stroke="rgba(6, 33, 27, 0.25)" strokeWidth="4" />
          <circle
            cx="20"
            cy="20"
            r={radius}
            fill="none"
            stroke={ringColor(value)}
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            style={{ transition: 'stroke-dashoffset 800ms cubic-bezier(0.16, 1, 0.3, 1)' }}
          />
        </svg>
        <span className="absolute flex flex-col items-center leading-none text-[#06211b]">
          <span className="font-bold" style={{ fontSize }}>{value}</span>
          <span className="font-semibold tracking-wide" style={{ fontSize: Math.max(8, Math.round(fontSize * 0.55)) }}>SEO</span>
        </span>
      </span>
      {onImprove ? (
        <button
          type="button"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onImprove();
          }}
          disabled={improving}
          className="mt-1 text-[10px] font-semibold text-[#d6ff4a] disabled:opacity-60"
        >
          {improving ? 'Improving' : 'Improve'}
        </button>
      ) : null}
    </span>
  );
}
